<template>

    <div class="feedback-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>問題反饋</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
            <img @click="showReplayInput('')" src="../assets/img_bianji.png" style="position: absolute;right: 10px;top: 25%;cursor: pointer;width: 6%" />
        </div>

        <div class="question-container">
            <ul>
                <li v-for="feedbacks in feedbackList">
                    <span style="color: #999999;font-size: 14px">{{feedbacks.insert_time}}</span>
                    <p style="color: #333333;font-size: 16px">{{feedbacks.content}}</p>
                    <img @click="showReplayInput(feedbacks.id)" src="../assets/img_add.png" />
                    <div style="margin-left: 20px" v-for="feedback in feedbacks.data">
                        <span style="color: #999999;font-size: 14px">{{feedback.insert_time}}</span>
                        <p style="color: #333333;font-size: 16px">{{feedback.content}}</p>
                    </div>
                </li>
            </ul>

            <div @click="loadMore" class="more-style" v-if="showLoadMore">
                <span>更多</span>
            </div>

        </div>

        <!--回復-->
        <div class="replay-container" v-show="showReplay">
            <input placeholder="請輸入..." v-model="replayContent" />
            <button @click="sendReplay">發送</button>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "FeedbackVue",
    data() {
        return {
            isRequest: false,
            userId: "",
            feedbackList: [],
            showReplay: false,
            replayPid: "",
            replayContent: "",
            page: 1,
            allPages: "",
            isLoadMore: false,
            showLoadMore: true,
        };
    },

    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },

        //獲取問題反饋列表
        getFeedbackList: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getOnlineService");
            params.append("uid", this.userId);
            params.append("page", this.page);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.allPage = res.data.pages;
                    this.showLoadMore = this.page < this.allPage;
                    if (this.isLoadMore) {
                        let list = res.data.data;
                        for (let i = 0; i < list.length; i++) {
                            this.feedbackList.push(list[i]);
                        }
                    } else {
                        this.feedbackList = res.data.data;
                    }
                } else {
                    this.showLoadMore = false;
                    alert(res.data.msg);
                }
            });
        },

        //加載更多
        loadMore: function () {
            this.isLoadMore = true;
            this.page++;
            this.getFeedbackList();
        },

        //顯示回復框
        showReplayInput: function (replayId) {
            this.showReplay = true;
            this.replayPid = replayId;
        },

        //發送
        sendReplay: function () {
            if (this.replayContent === null || this.replayContent === "") {
                alert("內容不能為空");
                return;
            }
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "saveOnlineService");
            params.append("uid", this.userId);
            params.append("content", this.replayContent);
            params.append("pid", this.replayPid);
            this.isRequest = true;
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.replayContent = null;
                    this.showReplay = false;
                    this.getFeedbackList();
                } else {
                    alert(res.data.msg);
                }
            });
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        this.getFeedbackList();
    },
};
</script>

<style scoped>
.feedback-container {
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
    background-color: white;
}

.question-container {
    margin-top: 50px;
    margin-bottom: 50px;
}

.question-container ul {
    text-align: left;
    padding-inline-start: 10px;
    padding-inline-end: 10px;
    width: 100%;
}

.question-container ul li {
    position: relative;
    border-bottom: 1px solid whitesmoke;
    padding-top: 10px;
    padding-bottom: 10px;
}

.question-container ul li span {
}

.question-container ul li p {
    margin-block-start: 0;
    margin-block-end: 0;
}

.question-container ul li img {
    position: absolute;
    right: 0;
    width: 7%;
    top: 10px;
}

.replay-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding-bottom: 5px;
    background-color: whitesmoke;
    padding-top: 5px;
}

.replay-container input {
    width: 70%;
    height: 40px;
    padding-left: 10px;
    outline: none;
    border-radius: 5px;
    border: 1px solid gray;
    color: black;
    font-size: 14px;
}

.replay-container button {
    width: 25%;
    height: 40px;
    border-radius: 3px;
    background-color: #f2c510;
    cursor: pointer;
    border: none;
    font-size: 16px;
    color: black;
    font-family: 楷體;
    margin-right: 3px;
}

.replay-container button:active {
    background-color: gray;
}

.more-style {
    height: 40px;
}

.more-style span {
    line-height: 40px;
}

.more-style:active {
    background-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedbackVue.vue